export const AGENCIES_FRAGMENT = `
fragment AgenciesSectionComponentFields on AgenciesSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
  agencies {
    locality {
      slug
      name
      coverPreviewHorizontal {
        url(
          transformation: {image: {resize: {width: $localityHorizontalImageWidth, height: $localityHorizontalImageHeight, fit: clip}}, document: {output: {format: webp}}}
        )
      }
      coverPreviewVertical {
        url(
          transformation: {image: {resize: {width: $localityVerticalImageWidth, height: $localityVerticalImageHeight, fit: clip}}, document: {output: {format: webp}}}
        )
      }
    }
  }
}
`;

export const HERO_SECTION_FRAGMENT = `
fragment HeroSectionComponentFields on HeroSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
  mobileImage {
    url(
      transformation: {image: {resize: {width: $heroImageSmallWidth, height: $heroImageSmallHeight, fit: clip}}, document: {output: {format: webp}}}
    )
  }
  desktopImage {
    url(
      transformation: {image: {resize: {width: $heroImageLargeWidth, height: $heroImageLargeHeight, fit: clip}}, document: {output: {format: webp}}}
    )
  }
  imageAlt
}
`;

export const GENERIC_SECTION_FRAGMENT = `
fragment GenericSectionComponentFields on GenericSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
}
`;

export const CTA_SECTION_FRAGMENT = `
fragment CTASectionComponentFields on CtaSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
  items {
    title
    subtitle
    content
    image {
      url(
        transformation: {image: {resize: {width: $ctaSectionImageWidth, height: $ctaSectionImageHeight, fit: clip}}, document: {output: {format: webp}}}
      )
    }
    imageAlt
    action {
      label
      href
    }
  }
}
`;

export const REVIEWS_SECTION_FRAGMENT = `
fragment ReviewsSectionComponentFields on ReviewsSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
}
`;

export const NEWS_SECTION_FRAGMENT = `
fragment NewsSectionComponentFields on NewsSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
}
`;

export const CONTACT_SECTION_FRAGMENT = `
fragment ContactSectionComponentFields on ContactSectionComponent {
  id
  title {
    markdown
  }
  subtitle {
    markdown
  }
  formTitle
}
`;

export const CONTACT_US_SECTION_FRAGMENT = `
fragment ContactUsSectionComponentFields on ContactUsSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
  formTitle{
    markdown
  }
}
`;

export const BANNER_SECTION_FRAGMENT = `
fragment BannerSectionComponentFields on BannerSectionComponent {
  id
  title
  subtitle
  content {
    markdown
  }
  image {
     url(
      transformation: {image: {resize: {width: $bannerSectionImageWidth, height: $bannerSectionImageHeight, fit: clip}}, document: {output: {format: webp}}}
    )
  }
  imageAlt
  cta {
    label
    href
  }
}
`;

export const REAL_ESTATE_SECTION_FRAGMENT = `
fragment RealEstateAgenciesSectionComponentFields on RealEstateAgenciesSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
}
`;

export const TEAM_SECTION_FRAGMENT = `
fragment TeamSectionComponentFields on TeamSectionComponent {
  id
  title {
    markdown
  }
  subtitle {
    markdown
  }
  content {
    markdown
  }
}
`;

export const JOIN_US_SECTION_FRAGMENT = `
fragment JoinUsSectionComponentFields on JoinUsSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
  image {
      url(
      transformation: {image: {resize: {width: $joinUsSectionImageWidth, height: $joinUsSectionImageHeight, fit: clip}}, document: {output: {format: webp}}}
    )
  }
  imageAlt
  ctaLabel
}
`;

export const LATEST_PROPERTIES_SECTION_FRAGMENT = `
fragment LatestPropertiesSectionComponentFields on LatestPropertiesSectionComponent {
  id
  title {
    markdown
  }
  subtitle {
    markdown
  }
  content {
    markdown
  }
  ctaLabel
}
`;

export const SOLD_PROPERTIES_SECTION_FRAGMENT = `
fragment SoldPropertiesSectionComponentFields on SoldPropertiesSectionComponent {
  id
  title {
    markdown
  }
  subtitle {
    markdown
  }
  content {
    markdown
  }
}
`;

export const SELL_PROPERTIES_SECTION_FRAGMENT = `
fragment SellPropertiesSectionComponentFields on SellPropertiesSectionComponent {
  id
  title {
    markdown
  }
  content {
    markdown
  }
  sellProperties {
    locality {
      slug
      name
      coverPreviewHorizontal{
        url(
          transformation:{
            image:{resize:{width: $localityHorizontalImageWidth, height: $localityHorizontalImageHeight, fit: clip}},
            document:{output:{format: webp}}
          }
        )
      }
      coverPreviewVertical{
        url(
          transformation:{
            image:{resize:{width: $localityVerticalImageWidth, height: $localityVerticalImageHeight, fit: clip}},
            document:{output:{format: webp}}
          }
        )
      }
    }
  }
}
`;

export const FAQ_SECTION_FRAGMENT = `
fragment FaqSectionComponentFields on FaqSectionComponent {
  id
  title {
    markdown
  }
  items {
    ... on Faq {
      question
      answer {
        markdown
        text
      }
    }
  }
}
`;
